export default class EffectCommandOptions {
  constructor(
    public loop?: boolean,
    public repeatCount?: number,
    public startIndex?: number,
    public endIndex?: number,
  ) {}
}
